import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a3285628&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3285628')) {
      api.createRecord('a3285628', component.options)
    } else {
      api.reload('a3285628', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a3285628&lang=pug", function () {
      api.rerender('a3285628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consultant/profile/certificates/removeCertificates/index.vue"
export default component.exports